import imagesUrls from "../../Constants/imagesUrls";

export default function ErrorPage({ heading, message, subMessage }) {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center">
      <div className="error-image-container">
        <img src={imagesUrls.no_state} width={180} alt="Error!" />
      </div>
      <div className="d-flex flex-column align-items-center justify-content-center  px-5">
        <div className="error-heading-text ">{heading}</div>
        <p className="error-description-text align-items-center justify-content-center mt-3">
          {message}
          <br />
          {subMessage}
        </p>
      </div>
    </div>
  );
}
